import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';

@Component({
  selector: 'app-remarkentry',
  templateUrl: './remarkentry.component.html',
  styleUrls: ['./remarkentry.component.scss'],
  providers:[MasterService,ClassroomService]
})
export class RemarkentryComponent implements OnInit {

  
 
  sections:any=[];
  classes:any=[];
  etype='sub';
  arrsubjects:any=[];
  fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0',stuid:'0'};
  arrrepdata:any=[];
  arrper:any=[];
  arrashead:any=[];
  arrastype:any=[];
  arrastype1:any=[];
  arrstudent:any=[];
  oprtype:any='';
  tabledata: any = {};
  arrcourse:any=[];
  arrcat:any=[{name:'Board'},{name:'Competitive'}];
  constructor(private http: HttpClient,private aservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }

  ngOnInit(): void {
    this.fmodel.ascat='Board';
    this.masasshead();
    this.masasstype();
    this.mascourse();
   

    
    //this.subjects();
    this.fmodel.attdt=this.mservice.getdatetoday();
    this.fmodel.frtime=this.mservice.getcurenttime();
    this.fmodel.totime=this.mservice.getcurenttime();
   
  }

  checknumber(ele) {
    if (ele.accscore < 0 || ele.accscore==null  )
    {

      ele.accscore = 0.00;
    }
    else if (ele.accscore > ele.maxscore) {
      alert('Marks should be less than or equal to maxscore');
      ele.accscore = ele.accscore1;

      console.log("accscore1", ele.accscore1 + " & " + ele.accscore);
    }
    // else {
    //   ele.accscore = parseFloat(ele.accscore).toFixed(0);
    // }
  }
  masclass() {
    this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.fmodel.clid=resultArray[0].clid;
            this.massection();
          //  this.masperiod();
            
           
        },
        error => console.log("Error :: " + error)
        )
  }

  masperiod() {
    this.mservice.masperiod(this.fmodel.clid)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrper = resultArray;
            this.fmodel.prid=resultArray[0].id;
           
           
        },
        error => console.log("Error :: " + error)
        )
  }
  massection() {
    this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.sections = resultArray;
            this.fmodel.secid=resultArray[0].scid;
           // this.masasshead();
           this.subjects();
        },  
        error => console.log("Error :: " + error)
        )
  }

  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrastype1 = resultArray;
          //  this.fmodel.assid=resultArray[0].asid;
           // this.masasstype();
           this.onchangeasscat();
        },
        error => console.log("Error :: " + error)
        )
  }
  masasstype() {
    this.mservice.sel_sp_masasstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrastype = resultArray;
            this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }
  mascourse() {
    this.mservice.mascourse()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrcourse = resultArray;
            this.fmodel.crid=resultArray[0].crid;
            this.masclass();
            //this.fmodel1.crid=resultArray[0].crid;
        },
        error => console.log("Error :: " + error)
        )
  }
onchangeasscat()
{
this.arrashead=this.arrastype1.filter(item => item.ascat===this.fmodel.ascat);
this.fmodel.assid=this.arrashead[0].asid;
this.SelectReportDetails();
}
 
  subjects() {
      this.mservice.subjectsrolewise(0,0,this.fmodel.clid,'asaa',this.fmodel.crid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrsubjects = resultArray;
              this.fmodel.subid=resultArray[0].suid;
          },
          error => console.log("Error :: " + error)
          )
    }

    getstudentsdata() {
      this.aservice.getstudents_clwise(this.fmodel.clid,this.fmodel.secid,this.fmodel.crid)
          .subscribe(
          resultArray => {
              console.log('bloodgp', resultArray);
              this.arrstudent = resultArray;
             this.fmodel.stuid= resultArray[0].stuid;
              // this.SelectReportDetails();
          },
          error => console.log("Error :: " + error)
          )
    }


    onclasschange()
    {
      this.massection();
this.subjects();
this.getstudentsdata();
    }

    onsecchange()
    {
      // this.massection();
// this.subjects();
this.getstudentsdata();
    }
    SelectReportDetails() {
      var clid = this.fmodel.clid;
      var secid = this.fmodel.secid;
      var assid = this.fmodel.assid;
      var asstypeid = this.fmodel.asstypeId;
      var subid = this.fmodel.subid;
      var stuid = this.fmodel.stuid;
      //var stuid = this.studata.stuid;
      //var name = this.studata.name;
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      var oprtype="";
      if(this.etype=="sub")
      {
        oprtype="selbyid";
      }
      else{

        oprtype="selbystuid";
      }
  
      var modeldata = { assid: assid, clid: clid, asstypeid: asstypeid, subid: subid, secid: secid,clcd:clcd,aycd:aycd,oprtype:oprtype,crid:this.fmodel.crid,stuid:stuid };
      //console.log('model',assid);   
      this.fmodel.dbnm = '';
     // this.model = f.value;
      console.log('model', modeldata);
      this.aservice.select_rmk_reportcard(modeldata)
        .subscribe(resultArray => {
          console.log('ret-select', resultArray);
          this.arrrepdata = resultArray;
          //alert (resultArray.message);
  
        }, error =>
          alert('error in connection')
        );
  
     
    }


    saveMarksDetails() {
      console.log('testdata', this.arrrepdata);
      this.tabledata.loopdata = this.arrrepdata;
      this.tabledata.dbnm = '';
  
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      this.tabledata.clcd=clcd;
      this.tabledata.aycd=aycd;
      // this.tabledata.oprtag='update';
      var oprtype="";
    
      // this.tabledata.oprtype=oprtype;
      console.log('marks-data', this.tabledata);
      this.aservice.loop_reportcard_rmk(this.tabledata)
        .subscribe(result => {
          console.log('ret-loop', result);
          alert(result.message);
          //this.Getsel_sp_masassmodel();
        }, error =>
          alert('error in connection')
        );
    }


}
